import e from "./TypesenseSearchResult.vue2.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const r = /* @__PURE__ */ o(e, [["__scopeId", "data-v-b084f1d5"]]);
export {
  r as default
};
